// extracted by mini-css-extract-plugin
export default {"filter":"VoiceRecording_filter__39+F4","cards":"VoiceRecording_cards__tRvE5","toggles-container":"VoiceRecording_toggles-container__B87DV"};